var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    style: {
      enableBackground: "new 0 0 100 125"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "35") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.4,46.8h-6.8l-7.3-11c-0.5-0.7-1.3-1.1-2.1-1.1h-25c-1.4,0-2.5,1.1-2.5,2.5v9.6h-4.8c-2.8,0-5,2.2-5,5v33.5 c0,2.8,2.2,5,5,5h48.5c2.8,0,5-2.2,5-5V51.8C68.4,49,66.2,46.8,63.4,46.8z M24.7,46.8v-7.1h21.2l4.7,7.1H24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.9,50.9c-0.7-0.5-1.6-0.5-2.4-0.2L73,57v23.1l13.5,6.3l1,0.2c1.4,0,2.5-1.1,2.5-2.5V53 C90.1,52.2,89.6,51.4,88.9,50.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecorder);
export default __webpack_public_path__ + "static/media/recorder.8ebc8d2484d582fe6af1d96773e7f409.svg";
export { ForwardRef as ReactComponent };